var _circle, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path5, _path6, _path7, _path8, _ellipse, _path9, _rect11, _path10, _path11, _ellipse2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCandidate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52,
    r: 52,
    fill: "#F2FBFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6626,
    y: 36.3016,
    width: 42.651,
    height: 52.129,
    rx: 6.96674,
    transform: "rotate(-5.72562 21.6626 36.3016)",
    fill: "#CAF0F8",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.0586,
    y: 31.9897,
    width: 38.0086,
    height: 46.455,
    rx: 6.20844,
    transform: "rotate(16.8433 56.0586 31.9897)",
    fill: "#CAF0F8",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.0924,
    y: 24.0472,
    width: 40.2768,
    height: 49.4137,
    rx: 6.2963,
    transform: "rotate(16.7054 53.0924 24.0472)",
    fill: "white",
    stroke: "#90E0EF",
    strokeWidth: 0.839506
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8368 52.8916C59.6426 50.2065 62.4726 48.6831 65.1577 49.4889L67.5887 50.2185C70.2738 51.0243 71.7973 53.8543 70.9914 56.5394L58.8368 52.8916Z",
    fill: "#00B4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8453 43.2655C63.6841 43.8025 63.9888 44.3685 64.5259 44.5297L64.4529 44.7728C64.0584 46.0874 64.5228 47.4554 65.5219 48.2744L65.1574 49.489L65.1817 49.4963C65.1422 49.57 65.1094 49.6488 65.0844 49.7321C64.883 50.4034 65.2638 51.1109 65.9351 51.3123C66.6064 51.5138 67.3139 51.1329 67.5154 50.4616C67.5403 50.3784 67.5564 50.2946 67.564 50.2113L67.5883 50.2186L67.9528 49.004C69.2378 48.8705 70.3788 47.9842 70.7733 46.6696L70.8463 46.4265C71.3833 46.5877 71.9493 46.283 72.1105 45.746C72.2716 45.209 71.9669 44.643 71.4299 44.4818C71.4017 44.4733 71.3734 44.4662 71.3451 44.4602C71.436 42.9663 70.4949 41.5513 68.9993 41.1024C67.5037 40.6536 65.9389 41.3165 65.1922 42.6136C65.1653 42.603 65.1377 42.5934 65.1095 42.5849C64.5725 42.4238 64.0065 42.7285 63.8453 43.2655Z",
    fill: "#ADE8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6829 46.5721C68.5861 46.8945 68.3653 47.1652 68.0689 47.3247C67.7726 47.4842 67.425 47.5195 67.1026 47.4228C66.7803 47.326 66.5096 47.1052 66.35 46.8088C66.1905 46.5125 66.1552 46.1649 66.252 45.8425L67.4674 46.2073L68.6829 46.5721Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7421 42.2446L65.0126 44.6756L64.5264 44.5297L65.6937 40.6402L65.955 40.7186C66.7912 39.7226 68.1691 39.2632 69.4938 39.6608L72.5979 40.5923L71.5765 43.9956L71.5764 43.9956L70.8468 46.4265L70.3606 46.2806L71.0902 43.8497L65.7421 42.2446Z",
    fill: "#03045E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.5229,
    y: 54.1063,
    width: 27.4108,
    height: 1.52282,
    transform: "rotate(16.7054 50.5229 54.1063)",
    fill: "#EAEAF1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5015,
    y: 57.5096,
    width: 10.6598,
    height: 1.52283,
    transform: "rotate(16.7054 49.5015 57.5096)",
    fill: "#EAEAF1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 48.188,
    y: 61.8854,
    width: 8.12173,
    height: 3.55325,
    rx: 1.67901,
    transform: "rotate(16.7054 48.188 61.8854)",
    fill: "#ADE8F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 57.4253,
    y: 64.6577,
    width: 8.12173,
    height: 3.55326,
    rx: 1.67901,
    transform: "rotate(16.7054 57.4253 64.6577)",
    fill: "#ADE8F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 8.12172,
    height: 3.55326,
    rx: 1.67901,
    transform: "matrix(0.957795 0.287451 -0.28745 0.957796 66.6631 67.4301)",
    fill: "#ADE8F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1885,
    y: 30.5717,
    width: 40.6351,
    height: 53.4451,
    rx: 6.75813,
    transform: "rotate(-5.72562 26.1885 30.5717)",
    fill: "#03045E",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3366,
    y: 26.3775,
    width: 47.9767,
    height: 58.8605,
    rx: 7.5,
    transform: "rotate(-6.371 15.3366 26.3775)",
    fill: "white",
    stroke: "#90E0EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.792 37.7763C36.6623 36.6147 37.4988 35.568 38.6603 35.4383L42.2658 35.0357C43.4274 34.906 44.4742 35.7425 44.6039 36.9041C44.7336 38.0656 43.8971 39.1124 42.7355 39.2421L39.13 39.6447C37.9684 39.7744 36.9217 38.9379 36.792 37.7763Z",
    fill: "#03045E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3917 41.5831C35.1508 39.4259 36.7043 37.4819 38.8615 37.241C41.0187 37.0001 42.9627 38.5536 43.2036 40.7108L43.2372 41.0113L35.4252 41.8835L35.3917 41.5831Z",
    fill: "#03045E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2081 40.3754C45.9672 38.2182 44.0232 36.6647 41.866 36.9056C39.7088 37.1465 38.1553 39.0905 38.3962 41.2477L38.4297 41.5481L46.2416 40.6759L46.2081 40.3754Z",
    fill: "#03045E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3584 41.2826L46.1749 40.0749L47.2484 49.6895L36.4319 50.8973L35.3584 41.2826Z",
    fill: "#03045E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.2684,
    cy: 42.448,
    rx: 3.93023,
    ry: 4.83721,
    transform: "rotate(-6.371 41.2684 42.448)",
    fill: "#ADE8F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.438 44.751C42.4647 44.99 42.3953 45.2299 42.2452 45.4178C42.095 45.6057 41.8763 45.7263 41.6373 45.753C41.3982 45.7797 41.1583 45.7103 40.9704 45.5602C40.7825 45.41 40.6619 45.1913 40.6353 44.9523L41.5366 44.8516L42.438 44.751Z",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.02326,
    height: 1.81395,
    transform: "matrix(0.993824 -0.110965 0.110966 0.993824 40.2358 46.8221)",
    fill: "#ADE8F4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8257 38.0768L42.2339 37.4729C42.4563 39.4642 41.0223 41.2587 39.031 41.481L37.2283 41.6823L36.8257 38.0768Z",
    fill: "#03045E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0987 55.3051C34.7281 51.9863 37.1181 48.9955 40.4369 48.6249L42.8406 48.3566C46.1593 47.986 49.1501 50.376 49.5207 53.6948L35.0987 55.3051Z",
    fill: "#0096C7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.9728,
    cy: 48.7576,
    rx: 1.51163,
    ry: 1.51163,
    transform: "rotate(-6.371 41.9728 48.7576)",
    fill: "#ADE8F4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4312,
    y: 37.6742,
    width: 3.6279,
    height: 1.81395,
    transform: "rotate(-6.37101 40.4312 37.6742)",
    fill: "#03045E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5547,
    y: 60.5179,
    width: 32.6512,
    height: 1.81395,
    transform: "rotate(-6.371 26.5547 60.5179)",
    fill: "#EAEAF1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0244,
    y: 64.7244,
    width: 12.6977,
    height: 1.81395,
    transform: "rotate(-6.37101 27.0244 64.7244)",
    fill: "#EAEAF1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 27.6284,
    y: 70.1326,
    width: 9.67442,
    height: 4.23255,
    rx: 2,
    transform: "rotate(-6.371 27.6284 70.1326)",
    fill: "#ADE8F4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0459,
    y: 68.8578,
    width: 9.67442,
    height: 4.23255,
    rx: 2,
    transform: "rotate(-6.371 39.0459 68.8578)",
    fill: "#ADE8F4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4634,
    y: 67.5829,
    width: 9.67441,
    height: 4.23255,
    rx: 2,
    transform: "rotate(-6.371 50.4634 67.5829)",
    fill: "#ADE8F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCandidate);
export default __webpack_public_path__ + "static/media/NoCandidate.e974c7355f1c43b49743ae83871c1c05.svg";
export { ForwardRef as ReactComponent };